/* Isolated preview host adapter. Never load alongside the rich host popup controller. */
(function(root){'use strict';
function install(options){
 const o=options||{};
 if(o.mode==='acf-only-mvp')return Object.freeze({enabled:false,reason:'MVP excludes optional offers',destroy(){}});
 if(o.hostPopupControllerDisabled!==true)throw Error('Disable the existing rich popup controller before installing this adapter.');
 const target=o.target;if(!target)throw Error('Explicit preview mount target required');
 if(target.hasAttribute('data-acfup-auto'))throw Error('Manual adapter mount cannot auto-mount');
 const api=root.ACFUPPreview.mount(target,{assetBase:o.assetBase,context:o.context,listenForPreviewRequest:false,beforeOpen(){
  document.querySelectorAll('dialog[open]').forEach(d=>d.close());
 }});
 function request(e){if(e.detail?.targetRoot&&e.detail.targetRoot!==target.id)return;
  if(e.detail?.key&&e.detail.key!=='iwe')return;
  if((api.snapshot().selected.includes('iwe')||api.snapshot().existing.includes('iwe'))){o.onContinue?.();return;}
  api.openIWE(e.detail?.trigger||document.activeElement);
 }
 document.addEventListener('acfrt:preview-request',request);
 return Object.freeze({enabled:true,previewOnly:true,purchaseEnabled:false,api,destroy(){document.removeEventListener('acfrt:preview-request',request);api.destroy();}});
}
root.ACFUPAdapter=Object.freeze({install,previewOnly:true,purchaseEnabled:false});
})(window);
